import { gql } from '../../../../../__generated__/graphql/catalog/gql'

export type ProductPageProps = {
  params: Promise<{
    collectionHandle?: string
    productHandle: string
  }>
  searchParams: Promise<{
    color?: string | string[]
    fit?: string | string[]
    size?: string | string[]
    fitModel?: string | string[]
  }>
}

export const PRODUCT_PAGE_QUERY = gql(`
  query GetProductPageData(
    $product: String!
    $color: String!
    $fit: String!
    $size: String!
  ) {
    productCatalogStandardProduct(handle: $product) {
      id
      handle
      variantGroup(color: $color) {
        id
        title
        gender
        availability
        urlPath
        primaryCategory {
          id
        }
        color {
          id
        }
        images {
          url
        }
        defaultShopifyProduct {
          id
        }
        variant(fit: $fit, size: $size) {
          id
          shopifyProductId
          shopifyId
          availability
        }
      }
    }
  }
`)
